import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FAR_EXCLAMATION_TRIANGLE } from 'const/icons'
import routes from 'const/routes'
import i18n from 'strings/i18n'
import { Button as BrandRefreshButton } from '@syf-cl/button'
import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import { isBrandRefreshEnabled } from 'helpers/getBrandRefreshPhase'
import theme from 'theme'

import { Container, Content, Title } from './subcomponents'

const PageNotFound = (): ReactElement => {
  const navigate = useNavigate()
  const brandRefreshEnabled = isBrandRefreshEnabled()
  const GoHomeButton: React.ElementType = brandRefreshEnabled
    ? BrandRefreshButton
    : CLButton
  const variantProps = brandRefreshEnabled
    ? { variant: 'primary', style: { textTransform: 'uppercase' as const } }
    : { buttonType: 'primary' }

  return (
    <Container>
      <FontAwesomeIcon
        icon={FAR_EXCLAMATION_TRIANGLE}
        size="2x"
        fill={theme.darkGrey}
      />
      <Title weight="bold" data-test="page-not-found-header">
        {i18n({ errors: 'sorryPage' })}
      </Title>
      <Content>{i18n({ errors: 'pageNotFound' })}</Content>
      <GoHomeButton
        {...variantProps}
        data-test="go-home-button"
        onClick={() => navigate(routes.HOME)}
      >
        {i18n({ button: 'goBackHome' })}
      </GoHomeButton>
    </Container>
  )
}

export default PageNotFound
